module.exports = "/static/fonts/sct-icons.eot";